export default __webpack_public_path__ + "static/media/PLU-BEERCARD-A4-3-bckg-1.0805253e.jpg";